<body>
    <app-spinner></app-spinner>
    <app-header *ngIf="showHeaderAndFooter"></app-header>
    <app-float-profile-bar *ngIf="showHeaderAndFooter" [userRoles]=""></app-float-profile-bar>
    <app-error-handler></app-error-handler>
    <main>
        <div>
            <router-outlet></router-outlet>
        </div>
    </main>
    <app-footer *ngIf="showHeaderAndFooter" class="d-none d-md-block"></app-footer>
</body>